export default __webpack_public_path__ + "static/BrownEntrataWeb-Light-6c11ce37f38a529b569ac4ff5882ddaa.woff";